import dynamic from 'next/dynamic'
import { LocationVisitsIcon } from 'src/components/insights/icons/location-visits'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/cross-visitation.png'

const CrossVisitation = dynamic(() => import('src/components/insights/location-visits/cross-visitation'), {
  ssr: false,
})

export const CrossVisitionWidget: InsightBuilderWidget = {
  id: 'cross-visitation',
  name: 'Cross Visitation',
  type: 'Location Visits',
  icon: LocationVisitsIcon,
  component: CrossVisitation,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
